import { render, staticRenderFns } from "./MyDocumentsTableBrief.vue?vue&type=template&id=b74fcd1c"
import script from "./MyDocumentsTableBrief.vue?vue&type=script&lang=ts"
export * from "./MyDocumentsTableBrief.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports